import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Leadform_Screen } from "../screens/leadform/leadform";
import { TalepForm_Screen } from "../screens/talepform/talepform";
import { HedefTipiList_Screen } from "../screens/hedeftipilist/hedeftipilist";
import { BayiProfil_Screen } from "../screens/bayiprofil/bayiprofil";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { BayiList_Screen } from "../screens/bayilist/bayilist";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { HedefTanim_Screen } from "../screens/hedeftanim/hedeftanim";
import { DealerBadges_List_Screen } from "../screens/dealerbadges_list/dealerbadges_list";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { BayiTanim_Screen } from "../screens/bayitanim/bayitanim";
import { Signup_Screen } from "../screens/signup/signup";
import { HedefList_Screen } from "../screens/hedeflist/hedeflist";
import { HedefTipiTanim_Screen } from "../screens/hedeftipitanim/hedeftipitanim";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { Signin_Screen } from "../screens/signin/signin";
import { BurhanTest_Screen } from "../screens/burhantest/burhantest";
import { HomePageBgImageView_Screen } from "../screens/homepagebgimageview/homepagebgimageview";
import { GrupDetay_Screen } from "../screens/grupdetay/grupdetay";
import { GrupForm_Screen } from "../screens/grupform/grupform";
import { GrupList_Screen } from "../screens/gruplist/gruplist";
import { LeadDetay_Screen } from "../screens/leaddetay/leaddetay";
import { KullaniciList_Screen } from "../screens/kullanicilist/kullanicilist";
import { KampanyaList_Screen } from "../screens/kampanyalist/kampanyalist";
import { FotoDrawer_Screen } from "../screens/fotodrawer/fotodrawer";
import { RolAtama_Screen } from "../screens/rolatama/rolatama";
import { TalepDetay_Screen } from "../screens/talepdetay/talepdetay";
import { KampanyaForm_Screen } from "../screens/kampanyaform/kampanyaform";
import { BayiBelgeList_Screen } from "../screens/bayibelgelist/bayibelgelist";
import { KullaniciDetay_Screen } from "../screens/kullanicidetay/kullanicidetay";
import { TalepList_Screen } from "../screens/taleplist/taleplist";
import { KampanyaDetay_Screen } from "../screens/kampanyadetay/kampanyadetay";
import { TalepBelgeForm_Screen } from "../screens/talepbelgeform/talepbelgeform";
import { HedefGerceklesmeOran_Screen } from "../screens/hedefgerceklesmeoran/hedefgerceklesmeoran";
import { TalepBelgeList_Screen } from "../screens/talepbelgelist/talepbelgelist";
import { BayiDashboard_Screen } from "../screens/bayidashboard/bayidashboard";
import { KullaniciForm_Screen } from "../screens/kullaniciform/kullaniciform";
import { NewPass_Screen } from "../screens/newpass/newpass";
import { DealerBadges_Form_Screen } from "../screens/dealerbadges_form/dealerbadges_form";
import { ExcelMaped_Screen } from "../screens/excelmaped/excelmaped";
import { BayiBelgeForm_Screen } from "../screens/bayibelgeform/bayibelgeform";
import { Test1_Screen } from "../screens/test1/test1";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  external_provider_type?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={HomePage_Screen} />
                        <PrivateRoute exact path="/leadform" component={Leadform_Screen} />
            <PrivateRoute exact path="/talepform" component={TalepForm_Screen} />
            <PrivateRoute exact path="/hedeftipilist" component={HedefTipiList_Screen} />
            <PrivateRoute exact path="/bayiprofil" component={BayiProfil_Screen} />
            <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/bayilist" component={BayiList_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/hedeftanim" component={HedefTanim_Screen} />
            <PrivateRoute exact path="/dealerbadges_list" component={DealerBadges_List_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/bayitanim" component={BayiTanim_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/hedeflist" component={HedefList_Screen} />
            <PrivateRoute exact path="/hedeftipitanim" component={HedefTipiTanim_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/burhantest" component={BurhanTest_Screen} />
            <PrivateRoute exact path="/homepagebgimageview" component={HomePageBgImageView_Screen} />
            <PrivateRoute exact path="/grupdetay" component={GrupDetay_Screen} />
            <PrivateRoute exact path="/grupform" component={GrupForm_Screen} />
            <PrivateRoute exact path="/gruplist" component={GrupList_Screen} />
            <PrivateRoute exact path="/leaddetay" component={LeadDetay_Screen} />
            <PrivateRoute exact path="/kullanicilist" component={KullaniciList_Screen} />
            <PrivateRoute exact path="/kampanyalist" component={KampanyaList_Screen} />
            <PrivateRoute exact path="/fotodrawer" component={FotoDrawer_Screen} />
            <PrivateRoute exact path="/rolatama" component={RolAtama_Screen} />
            <PrivateRoute exact path="/talepdetay" component={TalepDetay_Screen} />
            <PrivateRoute exact path="/kampanyaform" component={KampanyaForm_Screen} />
            <PrivateRoute exact path="/bayibelgelist" component={BayiBelgeList_Screen} />
            <PrivateRoute exact path="/kullanicidetay" component={KullaniciDetay_Screen} />
            <PrivateRoute exact path="/taleplist" component={TalepList_Screen} />
            <PrivateRoute exact path="/kampanyadetay" component={KampanyaDetay_Screen} />
            <PrivateRoute exact path="/talepbelgeform" component={TalepBelgeForm_Screen} />
            <PrivateRoute exact path="/hedefgerceklesmeoran" component={HedefGerceklesmeOran_Screen} />
            <PrivateRoute exact path="/talepbelgelist" component={TalepBelgeList_Screen} />
            <PrivateRoute exact path="/bayidashboard" component={BayiDashboard_Screen} />
            <PrivateRoute exact path="/kullaniciform" component={KullaniciForm_Screen} />
            <Route exact path="/newpass" component={NewPass_Screen} />
            <PrivateRoute exact path="/dealerbadges_form" component={DealerBadges_Form_Screen} />
            <PrivateRoute exact path="/excelmaped" component={ExcelMaped_Screen} />
            <PrivateRoute exact path="/bayibelgeform" component={BayiBelgeForm_Screen} />
            <PrivateRoute exact path="/test1" component={Test1_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    // Embedded MFE containers need to know whose routing space window.location.hash
    // is: theirs (pathname-routed shell) or the shell's own. A hash-routed shell
    // means a hash is never a microapp deep link — see mfe-initial-navigation.ts.
    //
    // First writer wins: an embedded microapp bundle runs its own copy of this
    // Router (always a HashRouter) on the SAME window, and it must not overwrite the
    // shell's answer. The shell's route tree renders before it can load any bundle,
    // so the first write is always the outermost app's.
    const isHashRouted: boolean = isWebComponentApp === true || this.props.routerType === "HashRouter";
    if (window.kuika.isShellHashRouted === undefined) {
      window.kuika.isShellHashRouted = isHashRouted;
    }

    if (isHashRouted) {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    const { external_provider_type } = this.props;
    // A Kuika host injects external_access_token as a short-lived MFE handoff
    // JWT; no refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed. A non-Kuika host injects its
    // own token plus external_provider_type, naming the customer's
    // External1..External5 validator that will verify it.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
            external_provider_type={external_provider_type}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
